import {
  BasicModel,
  ClientModel,
  DebtModel,
  EnterpriseModel,
  EquipmentModel,
  MasterModel,
  ReceiptModel,
  TalonModel,
  TYPE_SEARCH,
  UserModel
} from 'shared';
import { UUID } from 'symbols';
import { DocStatusDetails } from '../../../apps/frontend/src/app/status-selector/symbols';
import { User } from '../../../backend/src/user/entities/user.entity';

export enum StandStatus {
  ACCEPTED = 'ACCEPTED',
  ISSUED = 'ISSUED',
  ISSUED_SELF = 'ISSUED_SELF',
  READY_TO_PICKUP = 'READY_TO_PICKUP',
  INFORMED = 'INFORMED',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
}

export interface StandStatusExpectBackend {
  id?: UUID;
  status: StandStatus;
}

export interface StandModelExpectBackend extends BasicModel {
  id: string;
  masterId?: UUID;
  master?: UserModel;
  issuedAt: string;
  doneAt: string;
  informedAt: string;
  docNumber: number;
  reason: string;
  comment: string;
  talons?: TalonModel[],
  status: StandStatusExpectBackend;
  isHighPriority?: boolean;
  isDebt?: boolean;
  client?: ClientModel;
  clientId?: UUID;
  equipment?: Partial<EquipmentModel>;
  receipts?: ReceiptModel[];
  typeServiceId: UUID;
  isChanged?: boolean;
}


export interface StandModel extends BasicModel {
  issuedAt: string;
  informedAt: string;
  doneAt: string;
  docNumber: number;
  comment: string;
  reason: string;
  client?: ClientModel;
  clientId?: string;
  debt?: DebtModel;
  debtId?: string;
  equipment: Partial<EquipmentModel>;
  equipmentId?: string;
  receipts?: ReceiptModel[];
  receiptsIds?: string[];
  updater?: User;
  updaterId?: string;
  enterprise?: EnterpriseModel;
  enterpriseId?: string;
  status: StandStatusExpectBackend;
  statusId: string;
  typeServiceId: UUID;
  masterId: UUID;
  master?: MasterModel;
  isChanged: boolean;
  isHighPriority: boolean;
}


export interface StandFilterModel {
  isHighPriority?: boolean;
  isDebt?: boolean;
  isToxic?: boolean;
  masterId?: UUID;
  statusIds?: string[];
  searchText?: string;
  typeSearch?: TYPE_SEARCH;
}


export const STAND_STATUSES_RELATED_NAMES = {
  ['null']: 'Не обрано',
  [StandStatus.ACCEPTED]: 'Прийнята',
  [StandStatus.ISSUED]: 'Видана',
  [StandStatus.ISSUED_SELF]: 'Видана (WEB)',
  [StandStatus.CANCELLED]: 'Відмінена',
  [StandStatus.DONE]: 'Виконана',
  [StandStatus.INFORMED]: 'Проінформовано',
  [StandStatus.READY_TO_PICKUP]: 'Готово до видачі'
};

export const STAND_STATUSES_CONFIG: { [status: string]: DocStatusDetails } = {
  null: {
    id: null,
    background: 'none',
    availableAsOption: true,
    name: 'Не обрано',
    additionalConfirmation: false,
    confirmationText: '',
    detailsText: '',
    hint: 'Якщо статус не обрано, то замовлення не буде відображатись в списку замовлень.'
  },
  [StandStatus.ACCEPTED]: {
    id: StandStatus.ACCEPTED,
    name: STAND_STATUSES_RELATED_NAMES[StandStatus.ACCEPTED],
    background: 'var(--accepted)',
    hint: 'Замовлення було прийняте, але ще не видане майстру.',
    availableAsOption: true,
    additionalConfirmation: false
  },
  [StandStatus.ISSUED]: {
    id: StandStatus.ISSUED,
    name: STAND_STATUSES_RELATED_NAMES[StandStatus.ISSUED],
    background: 'var(--issued)',
    hint: '',
    availableAsOption: true,
    additionalConfirmation: true,
    detailsText: 'При зміні на цей статус, буде оновлено дату видачі замовлення.',
    confirmationText: 'Хочете продовжити?'
  },
  [StandStatus.ISSUED_SELF]: {
    id: StandStatus.ISSUED_SELF,
    name: STAND_STATUSES_RELATED_NAMES[StandStatus.ISSUED_SELF],
    background: 'var(--issued-self)',
    hint: 'Це замовлення було прийняте в роботу майстором самостійно через веб-додаток.',
    availableAsOption: false,
    additionalConfirmation: false
  },
  [StandStatus.CANCELLED]: {
    id: StandStatus.CANCELLED,
    name: STAND_STATUSES_RELATED_NAMES[StandStatus.CANCELLED],
    background: 'var(--cancelled)',
    hint: '',
    availableAsOption: true,
    additionalConfirmation: false
  },
  [StandStatus.DONE]: {
    id: StandStatus.DONE,
    name: STAND_STATUSES_RELATED_NAMES[StandStatus.DONE],
    background: 'var(--cancelled)',
    hint: '',
    availableAsOption: true,
    additionalConfirmation: false
  },
  [StandStatus.INFORMED]: {
    id: StandStatus.INFORMED,
    name: STAND_STATUSES_RELATED_NAMES[StandStatus.INFORMED],
    background: 'var(--informed)',
    hint: 'Замовлення уже виконано, але акти виконання ще не проведені.',

    availableAsOption: true,
    additionalConfirmation: false
  },
  [StandStatus.READY_TO_PICKUP]: {
    id: StandStatus.READY_TO_PICKUP,
    name: STAND_STATUSES_RELATED_NAMES[StandStatus.READY_TO_PICKUP],
    background: 'var(--ready-to-pickup)',
    hint: 'Замовлення уже виконано, але акти виконання ще не проведені.',

    availableAsOption: true,
    additionalConfirmation: false
  }
};


export interface StandsCountModel {
  acceptedCount: number;
  issuedCount: number;
}


export const STANDS_LOCAL_STORAGE_KEY = 'stands_data';
